import type { FunctionComponentWithRef } from "react";

import { Container, StyledBadge, StyledIconComment } from "./styles";

type Props = {
  className?: string;
  commentCount?: number;
  onClick?: () => void;
};

export const Article20Comment: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  commentCount,
  onClick,
  ref: forwardReference,
}) => (
  <Container className={className} onClick={onClick} ref={forwardReference}>
    <StyledBadge badgeContent={commentCount}>
      <StyledIconComment />
    </StyledBadge>
  </Container>
);

Article20Comment.displayName = "Article20Comment";
